import React from 'react';
import PropTypes from 'prop-types';

function MainContent(props) {
    var mainContentStyle = {
        marginBottom: '4rem',
        width: '100%'
    };

    return React.createElement(
        'div',
        { style: mainContentStyle },
        props.children
    );
}
MainContent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired])
};

export default MainContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-app/node_modules/@dhis2/d2-ui-core/build/es/layout/main-content/MainContent.component.js
// module id = 1980
// module chunks = 0